import { Tag, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { DUE_STATES, DueDateState } from 'modules/notifications/lib/DueDateState'

type Props = {
  state?: DueDateState | null
  dueOn?: moment.Moment | null
}

const DueStateLabel = ({ state, dueOn }: Props) => {
  switch (state) {
    case DUE_STATES.overdue:
      return (
        <Tag type="radical" inline>
          {i18n.t('dashboard.todo.due_date.overdue')}
        </Tag>
      )
    case DUE_STATES.dueToday:
      return (
        <Tag type="champagne" inline>
          {i18n.t('dashboard.todo.due_date.today')}
        </Tag>
      )
    case DUE_STATES.dueTomorrow:
      return (
        <Tag type="champagne" inline>
          {i18n.t('dashboard.todo.due_date.tomorrow')}
        </Tag>
      )
    case DUE_STATES.upcoming:
    case DUE_STATES.dueSoon:
      return <Text.Normal color="grey700">{dueOn?.format('ll')}</Text.Normal>
  }

  return <Text.Normal color="grey700">{i18n.t('employees.onboarding_task.no_date')}</Text.Normal>
}

export default DueStateLabel
